<div [ngClass]="tooltipPosition" class="flex-gap-5">
  <div class="form-check form-switch" data-cy="toggle-div">
    <input
      type="checkbox"
      class="form-check-input"
      tabindex="0"
      [id]="id"
      [ngModel]="model"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onNgModelChange($event)"
      [ngClass]="classesStringToggle"
      [attr.data-track-category]="trackCategory"
      [attr.data-track-action]="trackAction"
      [attr.data-cy]="dataCyAttribute"
      [disabled]="inputDisabled"
    />
    <label class="form-check-label" [for]="id" [ngClass]="classesString">
      {{ label | translate }}
    </label>
  </div>
  <div>
    @if (tooltipLabel && tooltipLabel.length > 0) {
      <info-tooltip class="align-self-center" [label]="tooltipLabel" [icon]="tooltipIcon"></info-tooltip>
    }
    @if (control && !control.pristine && !control.valid) {
      <div style="color: #f0142f">
        {{ errors | formError: formControlName | translate }}
      </div>
    }
  </div>
</div>
